import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    resetPassword,
    clearResetPassword,
} from '@perpay-web/fintech/actions/authentication';
import ResetPasswordForm from '@perpay-web/fintech/components/composite/ResetPasswordForm/ResetPasswordForm';
import {
    getResetPasswordError,
    getResetPasswordPath,
    getResetPasswordLoading,
} from '@perpay-web/fintech/selectors/authentication';

const BorrowerResetPasswordContainer = () => {
    const dispatch = useDispatch();

    const loading = useSelector(getResetPasswordLoading);
    const redirectPath = useSelector(getResetPasswordPath);
    const errorMessage = useSelector(getResetPasswordError);

    const onSubmit = useCallback(
        (payload) => {
            dispatch(resetPassword(payload));
        },
        [dispatch],
    );

    const clearHandler = useCallback(() => {
        dispatch(clearResetPassword());
    }, [dispatch]);

    return (
        <ResetPasswordForm
            loading={loading}
            redirectPath={redirectPath}
            errorMessage={errorMessage}
            onSubmit={onSubmit}
            clearHandler={clearHandler}
        />
    );
};

export default BorrowerResetPasswordContainer;
